<div class="modal-header" *ngIf="options.title">
  <h2 class="modal-title font-weight-bold" [innerText]="options.title"></h2>
  <button type="button" class="close" aria-label="Close" tabindex="-1" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p class="mb-0" [innerHtml]="options.content"></p>
</div>
<div class="modal-footer">
  <div class="d-flex flex-row justify-content-between w-100">
    <button type="button" class="btn btn-info w-100 mr-2" [innerText]="options.confirmBtnText || 'Confirm'" (click)="confirm()"></button>
    <button type="button" class="btn btn-danger w-100" [innerText]="options.closeBtnText || 'Close'" (click)="close()"></button>
  </div>
</div>
